export default "__VITE_ASSET__8G_jt3rw__"